export const FOLHA_PONTO_OLD = 'FOLHA_PONTO_OLD';
export const FOLHA_PONTO = 'FOLHA_PONTO';
export const PROGRAMACAO_DIARIA = 'PROGRAMACAO_DIARIA';
export const OLERITE = 'OLERITE';
